import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
//#endregion
//#region components
import { StyledButton } from "components/common";
import { useAnnualAccountService } from "serviceHooks";
import useManageAssistantsDialog from "./useManageAssistantsDialog";
//#endregion
import { DateHelper } from "utils/helpers";
import { getButtonLabel } from "./getButtonLabel";

const ManageAssistantsButton: React.FC = () => {
  const annualAccountsService = useAnnualAccountService();
  const annualAccountsFinancialYear = useSelector(
    (store: AppState) => store.auth.selectedCompany.annualAccountsFinancialYear
  );
  const { displayManageAssistantsDialog } = useManageAssistantsDialog();

  const [data, setData] = React.useState<WintSuperkollAPIModelAnnualAccounts.AnnualAccountsAuditorAssistantsResponse>();

  const fetchData = React.useCallback(() => {
    if (!annualAccountsFinancialYear?.id) return;
    annualAccountsService
      .getAuditorAssistants(annualAccountsFinancialYear.id)
      .then(setData)
      .catch(() => setData(undefined));
  }, [annualAccountsFinancialYear?.id]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (!data?.hasAuditor || annualAccountsFinancialYear?.id === undefined) {
    return null;
  }

  const openDialog = () => {
    displayManageAssistantsDialog({
      financialYearId: annualAccountsFinancialYear.id,
      period: DateHelper.formatDateRange(annualAccountsFinancialYear.start, annualAccountsFinancialYear.end, "-"),
      availableAuditors: data.availableAuditors ?? [],
      initialAssistants: data.selectedAssistants ?? [],
      onSaved: fetchData,
    });
  };

  return (
    <StyledButton secondary size="sm" onClick={openDialog}>
      {getButtonLabel(data.selectedAssistants)}
    </StyledButton>
  );
};

export default ManageAssistantsButton;
